<template>
    <div
      class="card-wrapper"
      v-touch:swipe.left="() => onSwipeLeft(shift, i)"
      v-touch:swipe.right="() => onSwipeRight(shift, i)"
      :class="{
        swipedLeft:
          showActions[i] &&
          (shift.abilities?.delete || shift.abilities?.exit) &&
          shift.status != 13,
      }"
    >
      <div class="job_shift_item1">
        <div class="job_shift_info1">
          <div class="job_shift_text">
            <div @click="handleClick(shift)" class="job_shift_user1">
              <template v-if="shift.locum">
                <el-avatar
                  :size="30"
                  shape="square"
                  :src="shift.locum.image"
                  v-if="shift.locum.image"
                />
                 <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                    v-else
                  >
                   <UserIcon />
                  </el-avatar>
                <div v-if="userRole == 'agency'">
                  <strong>
                    Locum: {{ shift.shiftAgencyLocum.firstName }}
                    {{ shift.shiftAgencyLocum.lastName }}
                  </strong>
                </div>
              </template>
              <template v-else-if="shift.status === 14">
                <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                  >
                   <UserIcon />
                  </el-avatar>
              </template>
              <template v-else>
                <template
                  v-if="
                    shift.applicationSelected == true &&
                    shift.applicationSelectedBy?.status == 2
                  "
                >
                  <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                  >
                   <UserIcon  />
                  </el-avatar>
                </template>
                <template v-else>
                  <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                  >
                   <UserIcon />
                  </el-avatar>
                </template>
                <div
                  class="locumate-progress"
                  v-if="shift.applicationSelected == false"
                >
                  <div
                    v-if="
                      userRole == 'pharmacy' &&
                      shift.shiftApplicationType != 0
                    "
                  >
                    <ProgressBar
                      :totalSlots="job.maximumApplicationLimit"
                      :filledSlots="shift.totalShiftApplications"
                    />
                  </div>
                </div>
              </template>
            </div>
            <div class="day_info">
              <div class="day_name header">
                <div class="day" v-if="isAustralia">
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                  }}
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format(
                      "DD MMM YYYY"
                    )
                  }}
                </div>
                <div class="day" v-else>
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                  }}
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format(
                      "MMM DD YYYY"
                    )
                  }}
                </div>
                <div class="d-flex more-button" v-if="userRole != 'agency'">
                  <el-button
                    class="text-only icon-button"
                    v-if="shift.locum"
                    @click="goToJobCalendar(shift)"
                  >
                    <CalendarIcon />
                  </el-button>
                  <el-button
                    class="button_more icon-button text-only-black"
                    icon="el-icon-more"
                    v-if="bottomDropUpExist(shift)"
                    @click="emit('update-bottom-drop-up', i, true)"
                  ></el-button>
                  <i
                    class="el-icon-arrow-right"
                    @click="goToJobCalendar(shift)"
                    v-else-if="shift.locum"
                  ></i>
                </div>
              </div>
            </div>
            <div class="info-wrapper">
              <div class="day_info_block">
                <ClockIcon />
                <div class="day_time data">
                  <span>{{
                    $moment(
                      shift.userStartTime || shift.startTime,
                      "HH:mm"
                    ).format("h:mm A")
                  }}</span>
                  -
                  <span>{{
                    $moment(
                      shift.userEndTime || shift.endTime,
                      "HH:mm"
                    ).format("h:mm A")
                  }}</span
                  >&nbsp;
                  <span v-if="showShiftInformation(shift)">
                    ({{
                      confirmedHours(
                        shift.confirmedHours,
                        shift.startTime,
                        shift.endTime
                      )
                    }}
                    Hours)</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="(!shift.shiftBookedAsInternalStaff &&
                    shift.isVisibileAsInternalLocum === false ) && userRole != 'agency'"
              >
                <div class="title">
                 <StopwatchIcon />
                </div>
                <div class="info">
                  <span v-if="showShiftInformation(shift)">
                    {{
                      shift.userBreakMinutes
                        ? getTimeFromMinutes(shift.userBreakMinutes)
                        : "-"
                    }}</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="
                  (!shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false ) && userRole != 'agency'
                "
              >
                <div class="title">
                 <TravelIcon />
                </div>
                <div
                  class="info"
                  v-if="job.settings.payingForTravel == 3 &&
                    job.maxTravelCompensation !== 0
                  "
                >
                  <span>{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                </div>
                <div class="info" v-else>
                  <span>Travel</span>
                </div>
                <div class="info">
                  <span v-if="showShiftInformation(shift)">
                    {{ travelCompensationCount(job, shift) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="
                  !shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false
                "
              >
                <div class="title">
                  <DollarWithCircleIcon />
                  <span
                    class="locumate_icons locumate_icon-check shift_confirm"
                    v-if="shift.confirmationDate"
                  ></span>
                </div>
                <div class="info rate" v-if="userRole != 'agency'">
                  <span
                    v-if="
                      (showShiftInformation(shift) &&
                        !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                      (showShiftInformation(shift) &&
                        job.openMarketplaceShiftForInternalLocum)
                    "
                    >{{ Rate(shift) }}</span
                  >
                  <span v-else>-</span>
                </div>
                <div class="info rate" v-if="userRole == 'agency'">
                  <span>{{ Rate(shift) }}</span>
                </div>
              </div>
              <template v-if="isAustralia && userRole != 'agency'">
                <div
                  class="day_info_block"
                  v-if="
                    !shift.shiftBookedAsInternalStaff &&
                    shift.isVisibileAsInternalLocum === false
                  "
                >
                  <div class="title">
                   <DollarWithCircleIcon />
                  </div>
                  <div class="info amount">
                    <span>Total Super</span>
                    <span
                      v-if="
                        (showShiftInformation(shift) &&
                          !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                        (showShiftInformation(shift) &&
                          job.openMarketplaceShiftForInternalLocum)
                      "
                    >
                      {{ totalSuperRate(shift) }}</span
                    >
                    <span v-else>-</span>
                  </div>
                </div>
              </template>
              <div
                class="day_info_block"
                v-if="
                  (!shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false) && userRole != 'agency'
                "
              >
                <div class="title">
                    <DollarWithCircleIcon />
                </div>
                <div class="info amount">
                  <span>Sum </span>
                  <span
                    v-if="
                      (showShiftInformation(shift) &&
                        !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                      (showShiftInformation(shift) &&
                        job.openMarketplaceShiftForInternalLocum)
                    "
                  >
                    {{ Sum(shift) }}</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="job_shift_text" v-if="isBlockShift === 0">
            <div
              class="job_application_wrapper"
              v-if="
                userRole == 'pharmacy' &&
                shift.shiftApplicationType !== 0 &&
                shift.locum == null
              "
            >
              <el-collapse
                accordion
                :model-value="activeCollapse"
                @update:model-value="emit('update-active-collapse', $event)"
                v-if="shift.shiftApplications?.length > 0"
              >
                <el-collapse-item
                  class="card-accordeon"
                  :title="`${shift.shiftApplications.length} Shift applicant${shift.shiftApplications.length > 1 ? 's' : ''}`"
                  :name="shift.id"
                >
                  <div
                    v-for="applicant in shift.shiftApplications"
                    :key="applicant.id"
                  >
                    <div class="collapse-list applicant-list">
                      <div class="collapse-item">
                        <div class="avatar-row avatar-row--col">
                          <div class="avatar-row-left">
                            <template v-if="applicant.locum">
                              <el-avatar
                                :size="'small'"
                                shape="square"
                                :src="applicant.locum.image"
                                v-if="applicant.locum.image"
                              />
                            <el-avatar :size="50" shape="square" class="grid-center gray" v-else>
                              <UserIcon :width="32" :height="32" :viewBox="'0 0 16 16'"/>
                            </el-avatar>
                            </template>
                            <p>
                              <span>{{ applicant.locum.name }}</span>
                              <span
                                class="text-secondary"
                                style="font-size: 12px"
                              >
                                Locum rate:
                                <span class="rate">{{
                                  formatCurrency(applicant.locumRate)
                                }}</span>
                              </span>
                            </p>
                            <div
                              v-if="
                                shift.applicationSelectedBy?.status == 2
                              "
                              class="ml-auto"
                            >
                              <el-tag
                                class="confirmation-status"
                                v-if="
                                  shift.applicationSelectedBy?.id ==
                                    applicant.id
                                "
                              >
                                Pending Confirmation
                              </el-tag>
                            </div>
                            <div
                              v-else
                              class="day_info_block_btn ml-auto"
                            >
                              <el-checkbox
                                class="c-label"
                                :checked="isSelected(applicant.id)"
                                @change="
                                  handleCheckboxChange(applicant.id)
                                "
                              ></el-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
        <el-drawer
          custom-class="bottom_drop_up"
          :model-value="bottomDropUp[i]"
          @update:model-value="(val) => emit('update-bottom-drop-up', i, val)"
          :append-to-body="true"
          :with-header="false"
          :direction="'btt'"
          :destroy-on-close="true"
        >
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="userRole == 'pharmacy' && shift.abilities?.update"
            @click="actions.editShift(job, shift, i)"
          >
            <EditOutlineIcon color="rgb(var(--locumate-clr-text))" :width="20" :height="20" />
            <span>Edit shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="
              userRole == 'pharmacy' &&
              shift.applicationSelected == false &&
              shift.shiftApplicationType !== 0 &&
              shift.locum == null
            "
            @click="actions.viewApplicants(job, shift, i)"
          >
            <EyeIcon color="rgb(var(--locumate-clr-text))" />
            <span>View Applicants</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="
              userRole == 'pharmacy' &&
              shift.applicationSelected == true &&
              !shift.userId
            "
            @click="actions.removeApplicants(job, shift, i)"
          >
            <UserRemoveIcon />  
            <span>Withdraw Applicant</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            @click="goToJobApplicants(shift.id)"
            v-if="
              !shift.userId &&
              shift.shiftApplicationType !== 0 &&
              userRole === 'pharmacy'
            "
          >
            <UsersIcon color="rgb(var(--locumate-clr-text))" :width="20" :height="20" />
            <span>All Applicants</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red mt-0"
            v-if="
              userRole === 'pharmacy' &&
              (shift.abilities?.delete || shift.abilities?.exit) &&
              shift.status != 13
            "
            @click="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
          >
            <TrashOutlineIcon :width="20" :height="20" />
            
            <span>Remove Shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red mt-0"
            v-if="
              userRole === 'locum' &&
              (shift.abilities?.delete || shift.abilities?.exit) &&
              shift.status != 13
            "
            @click="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
          >
            <TrashOutlineIcon :width="20" :height="20" />
            <span>Remove Shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red"
            v-if="userRole === 'pharmacy' && shift.status == 13"
            @click="actions.goToGuestShiftDetails(shift, i)"
            ><span
              class="locumate_icons locumate_icon-remove_square"
            ></span>
            <span>It's a Guest Shift</span>
          </el-button>
          <div
            v-else-if="
              !(shift.abilities?.delete || shift.abilities?.exit)
            "
            type="transparent"
            class="menu_item_reminder"
          >
            Please call {{ $filters.appName() }} on
            {{ $filters.appContactNumber() }} or email
            {{ $filters.appSupportEmail() }} to cancel this shift. A
            cancellation fee is applicable for shifts cancelled within
            72 hours of start time.
          </div>
        </el-drawer>
      </div>
      <div class="actions" v-show="showActions[i]">
        <button
          class="delete-btn"
          v-show="showActions[i]"
          v-if="
            userRole === 'pharmacy' &&
            (shift.abilities?.delete || shift.abilities?.exit) &&
            shift.status != 13
          "
          @click.prevent="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
        >
          <TrashIcon :color="'white'" :width="24" :height="24" />
        </button>
  
        <button
          class="delete-btn"
          v-show="showActions[i]"
          v-if="
            userRole === 'locum' &&
            (shift.abilities?.delete || shift.abilities?.exit) &&
            shift.status != 13
          "
          @click.prevent="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
        >
          <TrashIcon :color="'white'" :width="24" :height="24" />
        </button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { inject, getCurrentInstance, computed } from "vue";
  import { useStore } from "vuex";
  import moment from "moment";
  import ProgressBar from "../Days/ProgressBar.vue";
  import timeDiff from "@/helpers/date/timeDiff";
  import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
  import { 
    CalendarIcon, 
    ClockIcon, 
    DollarWithCircleIcon, 
    TravelIcon, 
    StopwatchIcon, 
    UserIcon, 
    EditOutlineIcon, 
    TrashOutlineIcon, 
    EyeIcon, 
    UsersIcon,
    UserRemoveIcon,
    TrashIcon,
  } from "@/components/Icons";
  
  // eslint-disable-next-line no-undef
  const props = defineProps({
    shift: {
      type: Object,
      required: true,
    },
    i: {
      type: Number,
      required: true,
    },
    job: {
      type: Object,
      required: true,
    },
    userRole: {
      type: String,
      required: true,
    },
    isBlockShift: {
      type: Number,
      required: true,
    },
    isAustralia: {
      type: Boolean,
      required: true,
    },
    showActions: {
      type: Array,
      required: true,
    },
    bottomDropUp: {
      type: Array,
      required: true,
    },
    activeCollapse: {
      type: String,
      default: "",
    },
    // Methods/functions that need parent state
    handleClick: {
      type: Function,
      required: true,
    },
    goToJobCalendar: {
      type: Function,
      required: true,
    },

    formatCurrency: {
      type: Function,
      required: true,
    },
    isSelected: {
      type: Function,
      required: true,
    },
    handleCheckboxChange: {
      type: Function,
      required: true,
    },
    goToJobApplicants: {
      type: Function,
      required: true,
    },
    actions: {
      type: Object,
      required: true,
    },
  });
    // eslint-disable-next-line no-undef
  const emit = defineEmits(['update-bottom-drop-up', 'update-active-collapse', 'update-show-actions']);
  
  const instance = getCurrentInstance();
  const $moment = inject("$moment");
  const $filters = instance?.appContext?.config?.globalProperties?.$filters || {};
  const $store = useStore();
  
  const userData = computed(() => $store.getters.GET_USER_DATA);
  
  // Functions moved from Details.vue - only used in ShiftCard
  const onSwipeLeft = (application, index) => {
    emit('update-show-actions', index, true);
  };
  
  const onSwipeRight = (application, index) => {
    emit('update-show-actions', index, false);
  };
  
  const bottomDropUpExist = () => {
    return true;
  };
  
  const confirmedHours = (confirmedHours, startTime, endTime) => {
    let result;
    if (confirmedHours == 0) {
      const start = moment(startTime, "HH:mm:ss");
      const end = moment(endTime, "HH:mm:ss");
      result = timeDiff(start, end);
    } else {
      const string = String(confirmedHours);
      const hours = string.split(".")[0];
      let minutes = string.split(".")[1];
      if (!minutes) {
        const time = hours + ":" + "00";
        result = String(time);
      } else {
        minutes = Number.parseFloat(`0.${minutes}`) * 60;
        result = hours + ":" + minutes.toFixed(0);
      }
    }
    return result;
  };
  
  const getTimeFromMinutes = (mins) => {
    if (mins >= 24 * 60 || mins < 0) {
      throw new RangeError(
        "Valid input should be greater than or equal to 0 and less than 1440."
      );
    }
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    return moment.utc().hours(h).minutes(m).format("HH:mm");
  };
  
  const showShiftInformation = (shift) => {
    if (props.userRole === "pharmacy") return true;
    if (
      shift?.job?.isInternalStaffOfThisPharmacy &&
      shift.shiftSubscription
    ) {
      return false;
    }
    if (!shift.userId) return true;
    if (shift.userId === userData.value.id) return true;
    return false;
  };
  
  const Rate = (shift) => {
    if (props.userRole === "pharmacy") {
      return shift.payRateExecSuper
        ? new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper)
        : "-";
    } else if (props.userRole == "agency") {
      return shift.shiftAgencyLocum.rate
        ? new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.shiftAgencyLocum.rate)
        : "-";
    } else {
      if (shift.locum == null && shift.payRateExecSuper == null) {
        return Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(shift.recommendedRate);
      } else {
        return Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(shift.payRateExecSuper);
      }
    }
  };
  
  const totalSuperRate = (shift) => {
    let confirmedHoursVal = 0;
  
    if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
      const start = moment(shift.startTime, "HH:mm:ss");
      const end = moment(shift.endTime, "HH:mm:ss");
      confirmedHoursVal = timeDiffAsDecimal(start, end);
    } else {
      confirmedHoursVal = shift.confirmedHours;
    }
  
    const superRate = shift.payRateSuper * confirmedHoursVal;
  
    return superRate
      ? Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(superRate)
      : "-";
  };
  
  const Sum = (shift) => {
    const globalTravelCompensationValue =
      process.env.VUE_APP_TRAVEL_COMPENSATION;
  
    let Sum;
    let confirmedHoursVal;
    let payRate;
    let travelCompensation;
    if (props.userRole === "locum") {
      if (shift.locum == null && shift.payRateExecSuper == null) {
        payRate = shift.recommendedRate;
      } else {
        payRate = shift.payRateExecSuper;
      }
    } else {
      payRate = shift.payRateExecSuper;
    }
    if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
      const start = moment(shift.startTime, "HH:mm:ss");
      const end = moment(shift.endTime, "HH:mm:ss");
      confirmedHoursVal = timeDiffAsDecimal(start, end);
    } else {
      confirmedHoursVal = shift.confirmedHours;
    }
  
    if (
      shift.travelCompensation === 0 &&
      shift.adminUpdatedTravelCompensation == false
    ) {
      let jobDistance = shift.distance ? shift.distance : null;
  
      if (jobDistance === null && props.job.distance) {
        jobDistance = props.job.distance;
      }
  
      if (jobDistance) {
        let distance = jobDistance;
  
        if (props.job.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            travelCompensation =
              (distance * 2 - 50) * globalTravelCompensationValue;
          } else {
            travelCompensation = shift.travelCompensation;
          }
        } else if (props.job.settings.payingForTravel == 2) {
          travelCompensation = distance * 2 * globalTravelCompensationValue;
        } else if (
          props.job.settings.payingForTravel === 3 &&
          props.job.maxTravelCompensation !== 0
        ) {
          let realTravelCost = distance * 2 * globalTravelCompensationValue;
          if (realTravelCost > props.job.maxTravelCompensation) {
            travelCompensation = props.job.maxTravelCompensation;
          } else {
            travelCompensation = distance * 2 * globalTravelCompensationValue;
          }
        }
      } else {
        travelCompensation = shift.travelCompensation;
      }
  
      if (!props.job.settings.payingForTravel) {
        travelCompensation = 0;
      }
    } else {
      if (!shift.shiftBookedAsInternalStaff ||
        shift.isVisibileAsInternalLocum === false) {
        travelCompensation = shift.travelCompensation;
      } else {
        travelCompensation = 0;
      }
    }
  
    if (payRate != null) {
      Sum = payRate * confirmedHoursVal + travelCompensation;
    } else {
      Sum = 0;
    }
  
    if (Sum != 0) {
      Sum = new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(Sum);
    } else {
      Sum = "-";
    }
  
    return Sum;
  };



  const travelCompensationCount = (job, shift) => {
        
        let travelCompensation = calculateTravelCompensation(job, shift); // Call the original function
        // For pharmacy if shift is not taken by anyone then show job max travel compensation instead of travel compensation after accepted by locum
        console.log(travelCompensation);
        
        if(shift.status === 0 && props.userRole === 'pharmacy') {
          return new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(job.maxTravelCompensation);
        }
        //check if is not numeric travelCompensation retuirn -
        if (isNaN(parseFloat(travelCompensation.replace(/[^0-9.-]+/g, "")))) {
          return "-";
        }
        if (job.enableTravelAllowanceForFirstAndLastDay === 1) {
          let numericValue = parseFloat(travelCompensation.replace(/[^0-9.-]+/g, ""));  
          // from backend in pharmacy side we are getting the travel compensation as half of the value already after accepted by locum from adminUpdatedTravelCompensation
          let halfCompensation = numericValue ;  
          // Format back to currency using Intl.NumberFormat
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(halfCompensation);
        }
  
        return travelCompensation; // Default behavior
      };
  
  
  const calculateTravelCompensation = (job, shift) => {
    
        if (!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false) {
          if (
            (shift.travelCompensation >= 0 &&
              shift.adminUpdatedTravelCompensation == true) ||
            (shift.travelCompensation === 0 &&
              shift.adminUpdatedTravelCompensation == true)
          ) {
            const convertedTravelRate = formatCurrency(shift.travelCompensation);
            return convertedTravelRate;
          }else if(shift.travelCompensation >= 0 ){
            const convertedTravelRate = formatCurrency(shift.travelCompensation);
            return convertedTravelRate;
          } else {
            if (
              job.settings.payingForTravel === 0 &&
              shift.adminUpdatedTravelCompensation == false
            ) {
              return "-";
            }
          }
  
          if (
            job.settings.payingForTravel === 3 &&
            job.maxTravelCompensation !== 0
          ) {
            let travelCompensation;
  
            //admin may change the travel compensation for the job via job menu in the admin panel
            //the changed travel compensation only reflects on the shifts that has not been booked
            //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
            //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
            //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
            let maxTravelCompensation =
              shift.jobMaxTravelCompensation && shift.userId
                ? shift.jobMaxTravelCompensation
                : job.maxTravelCompensation;
            const globalTravelCompensationValue =
              process.env.VUE_APP_TRAVEL_COMPENSATION;
              let jobDistance;
              if (shift.distance) {
              jobDistance = shift.distance;
            } else {
              jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
            }
  
            if (jobDistance) {
              let distance = jobDistance;
              travelCompensation = distance * 2 * globalTravelCompensationValue;
              if (travelCompensation > maxTravelCompensation) {
                const convertedTravelRate = formatCurrency(maxTravelCompensation);
                return convertedTravelRate;
              } else {
                travelCompensation = new Intl.NumberFormat("en-AU", {
                  style: "currency",
                  currency: "AUD",
                }).format(distance * 2 * globalTravelCompensationValue);
                return travelCompensation;
              }
            } else {
              const convertedTravelRate = formatCurrency(maxTravelCompensation);
              return convertedTravelRate;
            }
          } else {
            const convertedTravelRate = formatCurrency(+shift.travelCompensation);
            return convertedTravelRate;
          }
        } else {
          return "-";
        }
  
      };

      const formatCurrency = (rate) => {
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(rate);
      };
  </script>
  
